<template>
  <section>
    <b-card
      class="conctact-card mt-50 mb-2"
    >
      <b-col
        cols="8"
        class="mx-auto mt-1"
      >
        <span>
          {{ $tk('ClientPortal.Info.ContactUs') }}
        </span>
        <div class="text-center my-2">
          <b-img
            src="@/assets/illustrations/contact.png"
            height="200"
            width="264"
          />
        </div>
        <b-form-group
          :label="$tk('ClientPortal.Info.Subject') + ' *'"
          label-size="xs"
          :invalid-feedback="errors['Subject']"
        >
          <b-form-input
            v-model="contactModel.subject"
            size="sm"
            type="text"
            :placeholder="$tk('ClientPortal.Form.SubjectPlaceholder')"
            :state="errors['Subject'] == null ? null : false"
          />
        </b-form-group>
        <b-form-group
          :label="$tk('ClientPortal.Info.EmailAddress') + ' *'"
          label-size="xs"
          :invalid-feedback="errors['EmailAddress']"
        >
          <b-form-input
            v-model="contactModel.emailAddress"
            size="sm"
            type="email"
            :placeholder="$tk('ClientPortal.Form.EmailPlaceholder')"
            :state="errors['EmailAddress'] == null ? null : false"
          />
        </b-form-group>
        <b-form-group
          :label="$tk('ClientPortal.Info.Message') + ' *'"
          label-size="xs"
          :invalid-feedback="errors['Message']"
        >
          <b-form-textarea
            v-model="contactModel.message"
            :placeholder="$tk('ClientPortal.Deposit.MessagePlaceholder')"
            class="mb-2"
            no-resize
            :state="errors['Message'] == null ? null : false"
          />
        </b-form-group>
      </b-col>
    </b-card>
    <div class="border-top text-right py-1">
      <div class="mx-auto">
        <b-button
          class="bg-white ml-50"
          variant="primary"
          size="sm"
          :disabled="disabled"
          @click="sendEmail"
        >
          {{ $tk('ClientPortal.Info.Submit') }}
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import notification from '@/mixins/toastification'
import InfoService from '@/api/client/info.service'
import {
  ref,
} from '@vue/composition-api'

export default {
  mixins: [notification],
  setup() {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const contactModel = ref({
      subject: '',
      emailAddress: userData.email,
      message: '',
    })
    const errors = ref({})
    const disabled = ref(false)

    const sendEmail = async () => {
      disabled.value = true
      try {
        const response = await InfoService.sendContactEmail(contactModel.value)
        if (response.sent) {
          notification.methods.success(response.message)
          contactModel.value = {
            subject: '',
            emailAddress: '',
            message: '',
          }
          errors.value = {}
        } else {
          notification.methods.error(response.message)
          errors.value = response.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        disabled.value = false
      }
    }

    return {
      contactModel,
      errors,
      disabled,
      sendEmail,
    }
  },
}
</script>

<style lang="scss" scoped>
.conctact {
  &-card {
    height: calc(100vh - 188px); ;
    overflow-y: auto;
  }
}
</style>
